import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UtilityService } from "../../services/utility.service";
import { LoginComponent } from "./login/login.component";
import { SignupComponent } from "./signup/signup.component";
import { TranslateService } from "@ngx-translate/core";

@Component({
	selector: "app-auth",
	templateUrl: "./auth.component.html",
	styleUrls: ["./auth.component.scss"],
})
export class AuthComponent {
	@ViewChild(SignupComponent) private signupComponent: SignupComponent;
	@ViewChild(LoginComponent) private loginComponent: LoginComponent;

	tab: string = "none";
	popoverTitle: string = "title";

	constructor(
		private route: ActivatedRoute,
		private utilityService: UtilityService,
		private translateService: TranslateService
	) {
		this.route = route;
		this.utilityService = utilityService;
		this.translateService = translateService;
		this.route.queryParams.subscribe((params) => {
			if (Object.keys(params).length <= 0) {
				this.utilityService.redirectToLoginPage();
			}
		});
	}

	ngOnInit() {
		this.route.queryParams.subscribe((params) => {
			this.tab = params.tab;
			let key: string;
			if (this.tab === "signup") {
				key = "global.login.register_help.title";
			} else {
				key = "global.login.login_help.title";
			}
			this.translateService.get(key).subscribe((translation) => {
				this.popoverTitle = translation;
			});
		});
	}

	tabChange(data) {
		if (data.index === 0) {
			this.signupComponent.formReset();
		}
		if (data.index === 1) {
			this.loginComponent.formReset();
		}
	}
}
